import axios from "axios";
import { Message } from "element-ui";
import { getAccessToken } from "@/utils/cookie";
import { v4 as uuidv4 } from 'uuid';
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST;
const RmsApiHost = process.env.VUE_APP_RMS_API_HOST;
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST

// axios 初始化
const service = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  withCredentials: true,
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // },
  timeout: 180000
});

// 请求拦截器
service.interceptors.request.use(
  config => {

    //判断请求区分
    if (config.url == generalApiHost + '/oioc/code/generate') {
      config.timeout = 120000
    }

    config.headers["X-Platform"] = "aiot";

    var deviceid = localStorage.getItem('__DEVICEID__')
    if (!deviceid) {
      let str = uuidv4()
      deviceid = str.replace(/-/g, "").toUpperCase()
      localStorage.setItem('__DEVICEID__', deviceid)
    }
    config.headers["X-Deviceid"] = deviceid;

    // 每次请求前，向 http 头中插入 Access-Token
    if (getAccessToken()) {
      config.headers["Access-Token"] = getAccessToken();
    }
    return config;
  },
  error => {
    console.log(error + "请求拦截失败");
    Promise.reject(error);
  }
);

// 应答拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    console.log(error);
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
